import axios from "axios";
import { useEffect, useState } from "react";
import {
  Button,
  CloseButton,
  Form,
  Modal,
  Pagination,
  Spinner,
  Table,
} from "react-bootstrap";
import {
  AiFillCheckCircle,
  AiFillCloseCircle
} from "react-icons/ai";
import Layout from "../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import { PopUpModalButton } from "../../../components/basic/fileViewModal";
import { formatDateTimeStandard } from "../../../components/basic/simpleFunctions";
import { getURLbyEndPoint } from "../../../store/api";
import { getAuthUserCookie } from "../../../store/services";

import normalAxis from "../../../assets/axisImg/normalAxis.png";
import rotateAxis from "../../../assets/axisImg/rotatedAxis.png";

const NonStandDoc = () => {
  const [nonStandData, setNonStandData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [reqStatus, setReqStatus] = useState("Processing"); 

  const handleInputChange = (e, itemId) => {
    const { name, value } = e.target;
    setNonStandData((prevData) =>
      prevData.map((item) =>
        item._id === itemId ? { ...item, [name]: value } : item
      )
    );
  };

  const handleApiVal = (userId, value) => {
    setNonStandData((prevData) =>
      prevData.map((item) =>
        item._id === userId ? { ...item, appDisApi: value } : item
      )
    );
  };

  const handleApproveRejectNonStand = async (userId, status) => {
    const clientData = nonStandData.find((user) => user._id === userId);
    const userEmail = getAuthUserCookie().email;

    if (!userId || status === null || !clientData.remark) {
      alert("Please fill all fields");
      return;
    }

    if (status && clientData.nonStandDocs.some((data) => !data.isStampped)) {
      alert("Please stamp all documents before approving");
      return;
    }

    handleApiVal(userId, true);

    try {
      const res = await axios.post(
        getURLbyEndPoint("approveRejectNonStand") + userId,
        { status, remark: clientData.remark, approvedEmail: userEmail },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status) {
        alert(res.data.message);
        setNonStandData((prevData) =>
          prevData.map((item) =>
            item._id === userId
              ? { ...item, isApproved: status ? "Approved" : "Rejected" }
              : item
          )
        );
      } else {
        alert(res.data.message);
      }
    } catch (error) {
      alert("Error while handling non-standard data.");
      console.error("Error:", error);
    } finally {
      handleApiVal(userId, false);
    }
  };

  const filteredData = nonStandData.filter((data) => {
    const matchesStatus = reqStatus === "" || data.isApproved === reqStatus;
    const matchesSearch =
      searchTerm === "" ||
      data.appNo.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  // Pagination logic
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFiltered = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const calculateRange = (currentPage, totalPages) => {
    let startPage = Math.max(1, currentPage - 5);
    let endPage = Math.min(totalPages, currentPage + 4);

    if (endPage - startPage < 9) {
      if (startPage === 1) endPage = Math.min(10, totalPages);
      else if (endPage === totalPages) startPage = Math.max(totalPages - 9, 1);
    }

    return { startPage, endPage };
  };

  const { startPage, endPage } = calculateRange(currentPage, totalPages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 100);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    window.scrollTo(0, 100);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    window.scrollTo(0, 100);
  };

  const fetchNonStandDoc = async () => {
    try {
      const response = await axios.get(
        getURLbyEndPoint("getNonStandDocMaster")
      );
      if (response.status === 200) {
        const data = response.data.data.map((item) => {
          if (item.isApproved === "Processing") {
            const updatedNonStandDocs = item.nonStandDocs.map((doc) => {
              const stampPos = {};
              doc.stampPages.forEach((page) => {
                stampPos[page] = { xVal: 65, yVal: 10 };
              });
              return { ...doc, stampPos, isRotate: false };
            });
            return {
              ...item,
              remark: "",
              appDisApi: false,
              nonStandDocs: updatedNonStandDocs,
            };
          }
          return { ...item, appDisApi: false };
        });
        setNonStandData(data);
      } else {
        throw new Error("Failed to fetch data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      alert("Failed to fetch data. Please try again later.");
    }
  };

  useEffect(() => {
    fetchNonStandDoc();
  }, []);

  return (
    <Layout>
      <div className="d-flex flex-column justify-content-center align-items-center px-3">
        <div className="main-width d-flex flex-column">
          <hr />
          <DashboardHeader
            heading="Services/ Non Standard"
            backUrl="/master-services"
          />
          <hr />
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-3">
              <Form.Check
                inline
                label="All"
                name="group1"
                type="radio"
                checked={reqStatus === ""}
                onChange={() => setReqStatus("")}
              />
              <Form.Check
                inline
                label="Processing"
                name="group1"
                type="radio"
                checked={reqStatus === "Processing"}
                onChange={() => setReqStatus("Processing")}
              />
              <Form.Check
                inline
                label="Approved"
                name="group1"
                type="radio"
                checked={reqStatus === "Approved"}
                onChange={() => setReqStatus("Approved")}
              />
              <Form.Check
                inline
                label="Rejected"
                name="group1"
                type="radio"
                checked={reqStatus === "Rejected"}
                onChange={() => setReqStatus("Rejected")}
              />
            </div>
            <input
              className="form-control w-50"
              type="search"
              placeholder="Search By Application No."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div>
            <h6 className="text-danger">
              *In Each Service Approve all Document in sequence (For Reference
              No.)
            </h6>
            <Table responsive striped bordered hover>
              <thead>
                <tr className="text-center">
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Sr No.
                  </th>
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    User Name
                  </th>
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Application No. & Date Time
                  </th>
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Type Of Document & Country
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      width: "200px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Documents List
                  </th>
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Status
                  </th>
                  <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentFiltered.length > 0 ? (
                  currentFiltered.map((data, index) => (
                    <tr key={data._id} className="text-center">
                      <td>
                        {filteredData.length - indexOfFirstItem - index}.
                      </td>
                      <td>{data.email}</td>
                      <td>
                        {data.appNo}{" "}
                        <h6 className="text-success">
                          {formatDateTimeStandard(data.createdAt)}
                        </h6>
                      </td>
                      <td>
                        <h6>Type Of Document: {data.typeOfDoc}</h6>
                        <h6>Country: {data.country}</h6>
                      </td>
                      <td style={{ width: "max-content" }}>
                        <div
                          className="d-flex justify-content-between flex-wrap"
                          style={{ width: "230px", maxWidth: "max-content" }}
                        >
                          {data.nonStandDocs.map((docsData) => (
                            <div
                              className="col-md-6 mb-2 ps-0 text-start"
                              key={docsData._id}
                            >
                              <StampDocModal
                                fileId={docsData._id}
                                title={docsData.docName}
                                fileLink={docsData.docFile}
                                approved={data.isApproved === "Processing"}
                                stampPages={docsData.stampPages}
                                stampPos={docsData.stampPos}
                                noOfPages={docsData.noOfPages}
                                isStampped={docsData.isStampped}
                                docsData={docsData}
                                setNonStandData={setNonStandData}
                                isRotate={docsData.isRotate}
                              />
                            </div>
                          ))}
                        </div>
                        <div className="d-flex justify-content-start gap-1">
                          {data.reqLetterFlag && (
                            <PopUpModalButton
                              title="Request Letter"
                              fileLink={data.reqLetterFile}
                            />
                          )}
                          <PopUpModalButton
                            title="Receipt"
                            fileLink={data.receipt}
                          />
                        </div>
                      </td>
                      <td>
                        <h6
                          className={
                            data.isApproved === "Rejected"
                              ? "fw-semibold text-danger"
                              : "fw-semibold text-success"
                          }
                        >
                          {data.isApproved}
                        </h6>
                        {data.approvedEmail && (
                          <span style={{ fontSize: "0.7rem" }}>
                            by {data.approvedEmail}
                          </span>
                        )}
                      </td>
                      <td>
                        {data.isApproved === "Approved" ||
                          data.isApproved === "Rejected" ? (
                          <>
                            {data.isApproved === "Approved" && (
                              <h6>
                                Reference No.:{" "}
                                <span className="text-secondary">
                                  {data.refNo}
                                </span>
                              </h6>
                            )}
                            <h6>
                              Remark:{" "}
                              <span className="text-secondary">
                                {data.remark}
                              </span>
                            </h6>
                          </>
                        ) : (
                          <div className="max-content">
                            <Form.Control
                              as="textarea"
                              placeholder="Enter a Remark"
                              rows={3}
                              maxLength={120}
                              onChange={(e) => handleInputChange(e, data._id)}
                              value={data.remark}
                              name="remark"
                            />
                            {data.remark && (
                              <div className="d-flex justify-content-center gap-3 w-100 mt-3">
                                {data.appDisApi ? (
                                  <Spinner animation="border text-success" />
                                ) : (
                                  <>
                                    <Button
                                      className="m-0 p-0 border-none"
                                      style={{
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                      }}
                                    >
                                      <AiFillCheckCircle
                                        className="w-100 icon-size green-color"
                                        onClick={() =>
                                          handleApproveRejectNonStand(
                                            data._id,
                                            true
                                          )
                                        }
                                      />
                                    </Button>
                                    <Button
                                      className="m-0 p-0 border-none"
                                      style={{
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                      }}
                                    >
                                      <AiFillCloseCircle
                                        className="w-100 icon-size text-danger"
                                        onClick={() =>
                                          handleApproveRejectNonStand(
                                            data._id,
                                            false
                                          )
                                        }
                                      />
                                    </Button>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No Matching Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {totalPages > 1 && (
            <div className="d-flex justify-content-start mt-2">
              <Pagination>
                <Pagination.Prev
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                />
                {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                  <Pagination.Item
                    key={index + startPage}
                    active={index + startPage === currentPage}
                    onClick={() => handlePageChange(index + startPage)}
                  >
                    {index + startPage}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default NonStandDoc;

//stamping modals
function StampDocModal({
  fileId,
  title,
  fileLink,
  approved,
  stampPages,
  stampPos,
  noOfPages,
  isStampped,
  docsData,
  setNonStandData,
  isRotate,
}) {
  const [modalShow, setModalShow] = useState(false);
  const [updatedFileLink, setUpdatedFileLink] = useState(fileLink); // Tracks current file link (original or A4)
  const [tempA4FileLink, setTempA4FileLink] = useState(null); // Tracks temporary A4 file link
  const [checkStampApi, setCheckStampApi] = useState(false);
  const [addStampApi, setAddStampApi] = useState(false);
  const [convertA4Api, setConvertA4Api] = useState(false);

  useEffect(() => {
    setUpdatedFileLink(fileLink); // Reset to original file link when modal opens
    setTempA4FileLink(null); // Reset temp A4 link when modal opens
  }, [fileLink]);

  const handleStampPosChange = (val, pageNo, field) => {
    setNonStandData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.nonStandDocs) {
          const updatedNonStandDocs = item.nonStandDocs.map((doc) => {
            if (doc._id === fileId && doc.stampPos && doc.stampPos[pageNo]) {
              return {
                ...doc,
                stampPos: {
                  ...doc.stampPos,
                  [pageNo]: {
                    ...doc.stampPos[pageNo],
                    [field]: val,
                  },
                },
              };
            }
            return doc;
          });
          return { ...item, nonStandDocs: updatedNonStandDocs };
        }
        return item;
      });
      return updatedData;
    });
  };

  const handleRotateChange = () => {
    setNonStandData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.nonStandDocs) {
          const updatedNonStandDocs = item.nonStandDocs.map((doc) => {
            if (doc._id === fileId && doc.stampPos) {
              return { ...doc, isRotate: !doc.isRotate };
            }
            return doc;
          });
          return { ...item, nonStandDocs: updatedNonStandDocs };
        }
        return item;
      });
      return updatedData;
    });
  };

  const handleCheckStampPos = async (userId) => {
    setCheckStampApi(true);
    try {
      const response = await axios.put(
        getURLbyEndPoint("checkStampNonStand") + userId,
        {
          stampData: docsData.stampPos,
          isRotate: docsData.isRotate,
          tempFileLink: tempA4FileLink || fileLink, // Use temp A4 link if available
        },
        { headers: { "Content-Type": "application/json" }, responseType: "json" }
      );

      const responseData = response.data;
      const concatenatedChunks = responseData.chunks.reduce((acc, chunk) => {
        acc.push(...atob(chunk).split("").map((char) => char.charCodeAt(0)));
        return acc;
      }, []);

      const blob = new Blob([new Uint8Array(concatenatedChunks)], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      setUpdatedFileLink(url); // Update preview with checked stamp
      alert(responseData.message);
    } catch (error) {
      alert("Error while checking stamp on document.");
      console.error("Error:", error);
    } finally {
      setCheckStampApi(false);
    }
  };

  const handleDocStampAdded = async (userId) => {
    setAddStampApi(true);
    try {
      const res = await axios.put(
        getURLbyEndPoint("addStampNonStand") + userId,
        {
          stampData: docsData.stampPos,
          isRotate: docsData.isRotate,
          tempFileLink: tempA4FileLink || fileLink, // Use temp A4 link if available
        },
        { headers: { "Content-Type": "application/json" }, responseType: "json" }
      );
      setUpdatedFileLink(res.data.fileLink);
      alert(res.data.message);

      setNonStandData((prevData) => {
        const updatedData = prevData.map((item) => {
          if (item.nonStandDocs) {
            const updatedNonStandDocs = item.nonStandDocs.map((doc) => {
              if (doc._id === fileId) {
                return { ...doc, isStampped: true, docFile: res.data.fileLink };
              }
              return doc;
            });
            return { ...item, nonStandDocs: updatedNonStandDocs };
          }
          return item;
        });
        setModalShow(false);
        return updatedData;
      });
    } catch (error) {
      alert("Error while stamping on document.");
      console.error("Error:", error);
    } finally {
      setAddStampApi(false);
    }
  };

  const handleConvertToA4 = async (userId) => {
    setConvertA4Api(true);
    try {
      const res = await axios.put(
        getURLbyEndPoint("changeToA4") + userId,
        {},
        { headers: { "Content-Type": "application/json" }, responseType: "json" }
      );
      setUpdatedFileLink(res.data.fileLink); // Update preview with A4 version
      setTempA4FileLink(res.data.fileLink); // Store temporary A4 link
      alert(res.data.message);
    } catch (error) {
      alert("Error while converting to A4.");
      console.error("Error:", error);
    } finally {
      setConvertA4Api(false);
    }
  };

  return (
    <>
      <Button
        className="m-0 text-nowrap text-white rounded small-font"
        onClick={() => setModalShow(true)}
        variant={isStampped ? "primary" : "secondary"}
      >
        {title.length > 10 ? title.slice(0, 10) + "..." : title}
      </Button>

      <Modal show={modalShow} onHide={() => setModalShow(false)} size="xl" centered>
        <Modal.Header style={{ backgroundColor: "#0b3b5d", color: "white" }}>
          <Modal.Title>{title}</Modal.Title>
          <CloseButton variant="white" onClick={() => setModalShow(false)} />
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-3">
            <div className={approved && !isStampped ? "w-75" : "w-100"}>
              <iframe
                src={updatedFileLink}
                title={title}
                width="100%"
                height="700px"
                frameBorder="0"
              />
            </div>
            {approved && !isStampped && (
              <div className="w-25">
                <h5>Stamping Process:</h5>
                {stampPages.map((data, index) => (
                  <div key={index}>
                    <h6>For Page {data}:</h6>
                    <div className="d-flex gap-3 align-items-center mb-2">
                      <span>X:</span>
                      <Form.Control
                        type="text"
                        inputmode="numeric"
                        value={stampPos[data] ? stampPos[data].xVal : ""}
                        style={{ minWidth: "50px" }}
                        onInput={(e) => {
                          const value = e.target.value;
                          if (value === "0") e.target.value = "";
                          else if (!isNaN(value))
                            e.target.value = Math.max(0, parseInt(value) || 0)
                              .toString()
                              .slice(0, 3);
                          else e.target.value = "";
                        }}
                        onChange={(e) =>
                          handleStampPosChange(parseInt(e.target.value), data, "xVal")
                        }
                      />
                      <span>Y:</span>
                      <Form.Control
                        type="text"
                        inputmode="numeric"
                        value={stampPos[data] ? stampPos[data].yVal : ""}
                        style={{ minWidth: "50px" }}
                        onInput={(e) => {
                          const value = e.target.value;
                          if (value === "0") e.target.value = "";
                          else if (!isNaN(value))
                            e.target.value = Math.max(0, parseInt(value) || 0)
                              .toString()
                              .slice(0, 3);
                          else e.target.value = "";
                        }}
                        onChange={(e) =>
                          handleStampPosChange(parseInt(e.target.value), data, "yVal")
                        }
                      />
                    </div>
                  </div>
                ))}

                <div className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="isRotate"
                    className="me-2"
                    onChange={handleRotateChange}
                    checked={isRotate}
                  />
                  <h6>Rotate</h6>
                </div>

                <div className="d-flex flex-column gap-2 my-3">
                  <div className="d-flex gap-2">
                    <Button
                      className="w-100"
                      onClick={() => handleCheckStampPos(fileId)}
                      disabled={checkStampApi}
                    >
                      {checkStampApi ? "Processing..." : "CHECK"}
                    </Button>
                    <Button
                      variant="success"
                      className="w-100"
                      onClick={() => handleDocStampAdded(fileId)}
                      disabled={addStampApi}
                    >
                      {addStampApi ? "Processing..." : "STAMP"}
                    </Button>
                  </div>
                  <Button
                    variant="warning"
                    className="w-100"
                    onClick={() => handleConvertToA4(fileId)}
                    disabled={convertA4Api}
                  >
                    {convertA4Api ? "Converting..." : "CONVERT TO A4"}
                  </Button>
                </div>
                <div>
                  <img
                    src={isRotate ? rotateAxis : normalAxis}
                    width="auto"
                    height="200px"
                    alt="Axis"
                  />
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-start">
          <h6>Stamp Pages: {stampPages.join(", ")}</h6>
          <h6>No Of Pages Contain: {noOfPages}</h6>
        </Modal.Footer>
      </Modal>
    </>
  );
}